<div class="inner-content">
  <div class="main">

    <div class="chooser-wrapper">
      <p class="sidebar-header">
        {{ sidebarHeader }}
      </p>

      <div class="img-wrapper">
        <img src="/assets/people-2.png" srcset="/assets/people-2.png, /assets/people-2@2x.png 2x" />
      </div>

      <ng-content select="[page-sidebar]"></ng-content>
    </div>

    <div class="content-wrapper">
      <ng-content select="[page-content]"></ng-content>
    </div>
  </div>
</div>

<ns-fixed-element position="top">
  <div class="mobile-floater">
    <a routerLink="/">
      Powrót
    </a>
  </div>
</ns-fixed-element>
